import { useQuery } from "@tanstack/react-query";
import { mutualFollowersKeys } from "Api/Queries/Social/useMutualFollowersQuery";
import { getSocialMutualsIds } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

export const mutualFollowerIdsKeys = {
  all: [...mutualFollowersKeys.all, "IDS"] as const,
};

/**
 * The FULL set of mutual-follower ids (identityUserPublicID — which IS the Stream chat user id),
 * one unpaged request (App ADR-0014), so the chat Mutual tab can match channels against the
 * complete list rather than a single UI page. Ids alone stay small even at thousands; names and
 * avatars come from the paged mutuals list where they are rendered. Lives under the
 * SOCIAL_MUTUALS key family, so every social-graph mutation invalidates it along with the paged
 * lists.
 */
export const useMutualFollowerIdsQuery = () =>
  useQuery<ReadonlySet<string>>({
    queryKey: mutualFollowerIdsKeys.all,
    queryFn: async () => {
      const fetchAll = processResponseWithApiProblemDetails(() =>
        getSocialMutualsIds(),
      );

      return new Set(await fetchAll());
    },
    staleTime: MS_TIME.minute,
  });
